import keyMirror from 'keymirror';

export default keyMirror({
  SERVICE_LIST: null,
  AVAILABLE_TIME_SELECTION: null,
  SINGLE_EVENT_DETAILS: null,
  BOOKING_FORM: null,
  BOOKING_CONFIRMATION: null
});
